<template lang="pug">
	.app
		AppHeader(fixed)
			SidebarToggler.d-lg-none(display="md" mobile)
			b-link.navbar-brand(href="/")
				img.navbar-brand-full(src="/img/cadfem/cadfem-logo.svg" alt="myCADFEM Logo")
				img.navbar-brand-minimized(src="/img/cadfem/cadfem-logo-min.png" width="30" height="30" alt="Cadfem Logo")
			SidebarToggler.d-md-down-none(display="lg")
			// b-navbar-nav.d-md-down-none
				b-nav-item.px-3(to="/dashboard") Dashboard
				b-nav-item.px-3(to="/users" exact) Users
				b-nav-item.px-3 Settings
			b-navbar-nav.ml-auto
				// b-nav-item.d-md-down-none
					i.icon-bell
					b-badge(pill variant="danger") 5
				// b-nav-item.d-md-down-none
					i.icon-list
				// b-nav-item.d-md-down-none
					i.icon-location-pin
				DefaultHeaderDropdownAccnt

			// AsideToggler.d-none.d-lg-block
			// AsideToggler.d-lg-none(mobile)

		.app-body
			AppSidebar(fixed)
				SidebarHeader
				SidebarForm
				SidebarNav(:navItems="nav")
				SidebarFooter
				SidebarMinimizer
			main.main
				Breadcrumb.mb-0(:list="list")
				// max-width: 1440px; margin-right: unset; margin-left: unset;
				// .container-fluid(style="")
				router-view
			AppAside(fixed)
				<!--aside-->
				DefaultAside

		TheFooter
			<!--footer-->
			div.mb-2.mb-md-0
				a(href="https://www.cadfem-cis.ru/" target="_blank" rel="nofollow" style="color:black;") CADFEM CIS&reg;
				span.ml-1 {{ (new Date()).getFullYear() }}

			div.ml-auto
				a.d-block.d-md-inline.mr-2(href="tel:+74956440608" style="color:black;") +7 (495) 644-06-08
				a.d-block.d-md-inline(href="mailto:digital@cadfem-cis.ru" style="color:black;") digital@cadfem-cis.ru
</template>

<script>
	import nav from '@/_nav'
	import {
		Header as AppHeader,
		SidebarToggler,
		Sidebar as AppSidebar,
		SidebarFooter,
		SidebarForm,
		SidebarHeader,
		SidebarMinimizer,
		SidebarNav,
		Aside as AppAside,
		AsideToggler,
		Footer as TheFooter
	} from '@coreui/vue'
	import DefaultAside from './DefaultAside'
	import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

	import Breadcrumb from '../views/components/Breadcrumb.vue'

	export default {
		name: 'DefaultContainer',
		components: {
			AsideToggler,
			AppHeader,
			AppSidebar,
			AppAside,
			TheFooter,
			Breadcrumb,
			DefaultAside,
			DefaultHeaderDropdownAccnt,
			SidebarForm,
			SidebarFooter,
			SidebarToggler,
			SidebarHeader,
			SidebarNav,
			SidebarMinimizer
		},
		data() {
			return {
				nav: nav.items
			}
		},
		computed: {
			name() { return this.$route.name },
			list() { return this.$route.matched.filter((route) => route.name || route.meta.label) }
		}
	}
</script>
